export default "__VITE_ASSET__B0yw4kDS__"